import { tv } from '@change/ds-utils';

export const GroupHeaderStyles = tv({
	base: 'flex flex-row items-center',
	variants: {
		size: {
			xsmall: 'gap-[3px] p-[5px] pt-1',
			small: 'gap-[3px] p-[5px] pt-1',
			medium: 'gap-[7px] p-2.5 pb-[11px]',
			large: 'gap-2 p-3 pb-2.5',
		},
	},
});

export const GroupImageStyles = tv({
	base: 'outline-stroke-weaker overflow-hidden rounded-full outline outline-offset-0',
	variants: {
		size: {
			xsmall: 'h-3.5 w-3.5 outline-[0.5px]',
			small: 'h-3.5 w-3.5 outline-[0.5px]',
			medium: 'h-7 w-7 outline-[1px]',
			large: 'h-8 w-8 outline-[1px]',
		},
	},
});

export const GroupNameStyles = tv({
	base: 'line-clamp-2 font-[Arial] font-bold leading-[140%] tracking-[-1.1%]',
	variants: {
		size: {
			xsmall: 'max-w-[70px] text-[5px]',
			small: 'max-w-[70px] text-[5px]',
			medium: 'max-w-[145px] text-[10px]',
			large: 'max-w-[167px] text-[10px]',
		},
	},
});
